// Header.js

const Header = () => {
  return (
    <div className="header">
      <h1>
        Is the <span>book</span> better?
      </h1>
      <p>
        <span>Books</span> are better! No, <span>Movies</span> are better! Lets
        settle the debate! Write in your <span>favorite book</span> and see
        which one is better, once and for all!
      </p>
    </div>
  );
};

export default Header;
